<template>
  <svg :style="style" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Component 19" clip-path="url(#clip0_3654_48034)">
      <path id="Vector 38"
        d="M11.0507 7.35151L5.30805 1.60883C5.13481 1.43559 4.85567 1.64879 4.97723 1.86151L8.13968 7.39581C8.17657 7.46037 8.17657 7.53963 8.13968 7.60419L4.97723 13.1385C4.85567 13.3512 5.1348 13.5644 5.30805 13.3912L11.0507 7.64849C11.1327 7.56648 11.1327 7.43352 11.0507 7.35151Z"
        fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_3654_48034">
        <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>

</template>

<script>
export default {
  name: 'arrow-to-right',
  props: {
    width: {
      type: String,
      default: '14px'
    }
  },
  data() {
    return {
      style: {
        width: this.width,
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
      }
    }
  }
}
</script>